import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { TipoEmendaParlamentar } from '../TipoEmendaParlamentar';

export default function FormDetailPlanosTrabalhos({
  planosTrabalhos,
  tipo,
  isIntegradoOxy
}) {
  const items = planosTrabalhos || List();
  const isEmendaMunicipal = tipo === TipoEmendaParlamentar.MUNICIPAL;

  if (items.size === 0) {
    return <p className="text-muted">Nenhum Plano de Trabalho informado.</p>;
  }

  return (
    <>
      {items.map((item, index) => {
        const metas = item.get('metas', List());
        return (
          <React.Fragment key={index}>
            <DisplayData border className="mb-xs">
              <DisplayDataRow>
                <DisplayDataItem
                  sm={4}
                  title="Previsão Início"
                  value={item.get('dataInicio')}
                  id={`dataInicio-${index}`}
                />
                <DisplayDataItem
                  sm={4}
                  title="Previsão Fim"
                  value={item.get('dataFim')}
                  id={`dataFim-${index}`}
                />
              </DisplayDataRow>
              {(isIntegradoOxy || (!isIntegradoOxy && !isEmendaMunicipal)) && (
                <DisplayDataRow>
                  <DisplayDataItem
                    sm={12}
                    title="Metas"
                    value={
                      metas.size > 0 ? (
                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                          {metas.map((meta, i) => (
                            <li key={i}>{meta}</li>
                          ))}
                        </ul>
                      ) : (
                        'Nenhuma Meta informada.'
                      )
                    }
                    id={`metas-${index}`}
                  />
                </DisplayDataRow>
              )}
            </DisplayData>
            <hr className="mt-xs mb-xs" />
          </React.Fragment>
        );
      })}
    </>
  );
}

FormDetailPlanosTrabalhos.propTypes = {
  planosTrabalhos: PropTypes.object,
  tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
  isIntegradoOxy: PropTypes.bool
};
